import BaseTheme from '../base';

export default {
  ...BaseTheme.LineHeights,
  xxxs: '1.4rem',
  xxs: '1.6rem',
  xs: '1.8rem',
  s: '2rem',
  m: '2.4rem',
  l: '2.6rem',
  xl: '2.8rem',
  xxl: '3.2rem',
  xxxl: '3.4rem',
  xxxxl: '4.2rem',
  xxxxxl: '4.8rem',
  xxxxxxl: '6.6rem',
  xxxxxxxl: '7.4rem',
  xxxxxxxxl: '8.6rem'
};
